export default function MenuIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M17.37,5.23H2.63a1,1,0,1,1,0-1.91H17.37a1,1,0,1,1,0,1.91Zm0,5.72H6.67a1,1,0,1,1,0-1.9h10.7a1,1,0,1,1,0,1.9Zm0,5.73H2.63a1,1,0,1,1,0-1.91H17.37a1,1,0,1,1,0,1.91Z" />
    </svg>
  )
}
